module.exports = __webpack_public_path__ + "static/img/mast_83K.a6fdb43.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/products/mast_83K.jpg
// module id = /PAn
// module chunks = 0